@if (auth.user(); as u) {
  <div class="shell">
    <aside class="rail" aria-label="Main navigation">
      <a class="brand" routerLink="/">
        <span class="logo" aria-hidden="true">
          <svg viewBox="0 0 28 28" width="28" height="28"><rect width="28" height="28" rx="7" fill="#e84e1b"/><path d="M9 19V9h5.2a3.4 3.4 0 0 1 0 6.8H9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <span class="name">Payments</span>
        <span class="env" [class.dev]="env === 'DEV'">{{ env }}</span>
        <span class="dot" [class.ok]="apiOk() === true" [class.fail]="apiOk() === false"
              [title]="apiOk() === null ? 'Checking the server' : apiOk() ? 'Server, database and Redis are up' : 'Server problem'"></span>
      </a>

      <nav class="nav">
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Overview</a>
        <p class="group">Companies</p>
        @for (c of companies.list(); track c.id) {
          <a [routerLink]="['/companies', c.id]" routerLinkActive="active">
            <span class="sw" [style.background]="c.color"></span>
            <span class="cname">{{ c.name }}</span>
            @if (c.summary.plans_without_price) {
              <span class="todo num" [title]="c.summary.plans_without_price + ' plans on sale without a price'">{{ c.summary.plans_without_price }}</span>
            }
          </a>
        }
      </nav>

      @if (auth.isAdmin()) {
        <nav class="nav foot-nav"><a routerLink="/users" routerLinkActive="active">Team</a></nav>
      }
      <div class="me">
        <span class="who">{{ u.name }}<small class="role">{{ u.role === 'admin' ? 'Admin' : 'Sales' }}</small></span>
        <button class="out" (click)="logout()">Sign out</button>
      </div>
    </aside>
    <main class="main"><router-outlet /></main>
  </div>
} @else {
  <router-outlet />
}
